import React from 'react';
import AIIllustrationVocabularyTab from './tabs/AIIllustrationVocabulary';

const AIIllustration: React.FC = () => {
  return <AIIllustrationVocabularyTab />;
};

export default AIIllustration;
